import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-766ac64b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "promotion-calender-warp"
};
const _hoisted_2 = {
  class: "search-warp mg-b--30"
};
const _hoisted_3 = {
  class: "tabs"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "search-input"
};
const _hoisted_6 = {
  class: "statedate-warp mg-b--30"
};
const _hoisted_7 = {
  class: "state"
};
const _hoisted_8 = {
  class: "state-name"
};
const _hoisted_9 = {
  class: "date"
};
import Calender from './calender.vue';
import dayjs from 'dayjs';
import { onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const currentTabsActiveName = ref('year');
    const tabsList = ref([{
      label: t('年'),
      value: 'year'
    }, {
      label: t('月'),
      value: 'month'
    }]);

    const changeTabActiveName = name => {
      isLoading.value = true;
      currentTabsActiveName.value = name;

      if (name == 'month') {
        let currentYear = Number(promotionYear.value);
        let currentMonth = Number(promotionMonth.value.split('-')[1]);
        console.log(promotionMonth.value, currentMonth);
        promotionMonth.value = `${currentYear}-${formatNum(currentMonth)}`;
      } else {
        let currentYear = promotionMonth.value.split('-')[0];
        promotionYear.value = currentYear;
      }

      setTimeout(() => {
        isLoading.value = false;
      }, 1000);
    }; // 对应状态的颜色


    const stateColor = {
      0: '#29b87d',
      1: '#f2994a',
      2: '#f92d2d',
      3: '#b4b4b4'
    };

    const getStatus = status => {
      return status == '0' ? t('促销中') : status == '1' ? t('未开始') : status == '2' ? t('中止') : t('已过期');
    };

    const isLoading = ref(false);
    const promotionYear = ref('');
    const promotionMonth = ref('');
    const promotionData = ref([]);
    onBeforeMount(() => {
      promotionYear.value = dayjs().format('YYYY');
      promotionMonth.value = dayjs().format('YYYY-MM');
    });

    const formatNum = num => Number(num) <= 9 ? `0${num}` : num;

    const getMonth = (now, type) => {
      let cNow = type == 'pre' ? now - 1 : now + 1;

      if (cNow <= 0) {
        changeYear('pre');
        return 12;
      }

      if (cNow > 12) {
        changeYear('next');
        return formatNum(1);
      }

      return formatNum(cNow);
    };

    const changeYear = type => {
      let currentYear = Number(promotionYear.value);
      promotionYear.value = type == 'pre' ? String(currentYear - 1) : String(currentYear + 1);
    };

    const changeDate = type => {
      if (currentTabsActiveName.value == 'year') {
        changeYear(type);
      } else {
        let currentMonth = Number(promotionMonth.value.split('-')[1]);
        console.log(promotionMonth.value, currentMonth);
        let nextMonth = getMonth(currentMonth, type);
        promotionMonth.value = `${promotionYear.value}-${nextMonth}`;
      }
    };

    watch(() => promotionYear.value, val => {
      promotionData.value = [];

      for (let i = 1; i <= 12; i++) {
        promotionData.value.push(`${val}-${formatNum(i)}`);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_skeleton = _resolveComponent("el-skeleton");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsList.value, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass(["tab-item pointer", item.value == currentTabsActiveName.value ? 'is-tab-active' : '']),
          onClick: $event => changeTabActiveName(item.value)
        }, _toDisplayString(item.label), 11, _hoisted_4);
      }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        class: "",
        placeholder: _ctx.$t('Please input promotion name')
      }, null, 8, ["placeholder"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(stateColor, (item, index) => {
        return _createElementVNode("li", {
          class: "state-item",
          key: index
        }, [_createElementVNode("span", _hoisted_8, _toDisplayString(getStatus(index)) + ": ", 1), _createElementVNode("span", {
          class: "state-bg",
          style: _normalizeStyle(`background:${stateColor[index]}`)
        }, null, 4)]);
      }), 64))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "pro-date-icon pointer",
        onClick: _cache[0] || (_cache[0] = $event => changeDate('pre'))
      }, _toDisplayString('<')), currentTabsActiveName.value == 'year' ? (_openBlock(), _createBlock(_component_el_date_picker, {
        key: 0,
        modelValue: promotionYear.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => promotionYear.value = $event),
        "value-format": "YYYY",
        type: "year",
        size: "large",
        clearable: false,
        placeholder: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), currentTabsActiveName.value == 'month' ? (_openBlock(), _createBlock(_component_el_date_picker, {
        key: 1,
        modelValue: promotionMonth.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => promotionMonth.value = $event),
        size: "large",
        clearable: false,
        "value-format": "YYYY-MM",
        type: "month",
        placeholder: ""
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "pro-date-icon pointer",
        onClick: _cache[3] || (_cache[3] = $event => changeDate('next'))
      }, _toDisplayString('>'))])]), _createElementVNode("div", {
        class: "calender-warp",
        style: _normalizeStyle(currentTabsActiveName.value == 'year' ? 'justify-content: space-between;' : 'justify-content: center;')
      }, [isLoading.value ? (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 0,
        rows: 5,
        animated: ""
      })) : _createCommentVNode("", true), !isLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [currentTabsActiveName.value == 'year' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(promotionData.value, (item, index) => {
        return _openBlock(), _createBlock(Calender, {
          style: {
            "width": "500px",
            "height": "500px"
          },
          key: index,
          "initial-date": item
        }, null, 8, ["initial-date"]);
      }), 128)) : _createCommentVNode("", true), currentTabsActiveName.value == 'month' ? (_openBlock(), _createBlock(Calender, {
        key: 1,
        style: {
          "width": "500px",
          "height": "500px"
        },
        "initial-date": promotionMonth.value
      }, null, 8, ["initial-date"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 4)]);
    };
  }

});